/* Mængderabat 1 / 6+ / 12+. Kører efter tt-product.js og overskriver pris og total med trinprisen */
(function () {
  var wrap = document.querySelector('[data-tt-tiers]');
  var qty = document.getElementById('tt-qty');
  if (!wrap || !qty) return;
  var tiers = Array.prototype.slice.call(wrap.querySelectorAll('.tt-tier'));
  var priceEl = document.getElementById('tt-price');

  function fmt(c) {
    var v = c / 100;
    return v.toLocaleString('da-DK', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' kr';
  }
  function tierFor(q) {
    var t = tiers[0];
    tiers.forEach(function (x) { if (q >= parseInt(x.dataset.qty, 10)) t = x; });
    return t;
  }
  function sync() {
    var q = Math.max(1, parseInt(qty.value, 10) || 1);
    var t = tierFor(q);
    tiers.forEach(function (x) {
      var on = x === t;
      x.classList.toggle('is-sel', on);
      x.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var each = parseInt(t.dataset.each, 10);
    if (priceEl) priceEl.textContent = fmt(each);
    document.querySelectorAll('[data-tt-total]').forEach(function (el) { el.textContent = fmt(each * q); });
  }
  var later = function () { setTimeout(sync, 0); };

  tiers.forEach(function (t) {
    t.addEventListener('click', function () {
      qty.value = t.dataset.qty;
      qty.dispatchEvent(new Event('change'));
      later();
    });
  });
  qty.addEventListener('change', later);
  qty.addEventListener('input', later);
  document.querySelectorAll('[data-tt-q]').forEach(function (b) { b.addEventListener('click', later); });
  document.addEventListener('DOMContentLoaded', later);
  later();
})();